import axios from 'axios'
const state = {
    branch_types: null,
    branches: [],
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
}
const getters = {
    getTableOptions(state) {
        return state.tableOptions;
    },
    getBranchTypes(state) {
        return state.branch_types;
    },
    getBranches(state) {
        return state.branches;
    }
}
const mutations = {
    setBranchType(state, data) {
        state.branch_types = data;
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setBranches(state, data) {
        state.branches = data;
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    }
}
const actions = {
    async fetchBranchTypes({ commit }, queryParams) {
        try {
            const res = await axios.get("branch/types");
            commit('setBranchType', res.data.data );
        } catch (error) {
            
        }
    },
    async fetchBranches({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key]
                }
            }
            const response = await axios.get("/branch", {
                params,
            });
            commit('setBranches', response.data.data );
            commit('setTableData', {
                tableHeaders: ["id", "name","Type","phone number","City","address", "settings"],
                tableData: response.data.data,
                accessTableData: [["id"], ["name"],["type"],["phone"],["city"],["address"]],
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}